
<template>
  <div
    id="app"
    v-on:touchstart="bodyTouchStart"
    v-on:touchmove="bodyTouchMove"
    v-on:touchend="bodyTouchEnd"
    :style="{background:backgTheme=='dark'?'#1a1a1a':''}"
  >
    <transition :name="transitionName">
      <router-view class="appView" v-if="isRouterAlive" :key="new Date().getTime()"></router-view>
    </transition>
  </div>
</template>

<script>
var swidth = document.documentElement.clientWidth;
import untils from "./config/utils.js";
import { mapState } from "vuex";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      backgTheme: "",
      transitionName: "",
      // touchLeft 划动起点界限，起点在靠近屏幕左侧时才有效
      touchLeft: (swidth * 2) / 5,
      // touchStartPoint 记录起始点X坐标
      touchStartPoint: 0,
      // distance 记录划动的距离
      distance: 0,
      // 回退按钮的dom，根据页面上是否存在此dom来判断该路由是否可回退
      backBtn: null,
      isRouterAlive: true
    };
  },
  created() {
    this.getSetting();
    this.changeSetting();
    this.getCommonPamas();
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to的索引值为0，不添加任何动画；如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(to.path.indexOf('articleDetail')>-1&&from.path.indexOf('articleDetail')>-1){
        this.transitionName = "";
        return
      }
      if(to.path.indexOf('articleDetail')>-1&&(from.path.indexOf('labelPage')>-1||from.path.indexOf('search')>-1)){
        this.transitionName = "slide-left";
        return
      }
      if((to.path.indexOf('labelPage')>-1||to.path.indexOf('search')>-1)&&from.path.indexOf('articleDetail')>-1){
        this.transitionName = "slide-right";
        return
      }
      if (to.meta.index > 0) {
        if (to.meta.index < from.meta.index) {
          this.transitionName = "slide-right";
        } else {
          this.transitionName = "slide-left";
        }
      } else if (to.meta.index == 0 && from.meta.index > 0) {
        this.transitionName = "slide-right";
      }
      //当然，如果你没有需要设置索引值为0的页面可以直接用着一段
      /*if( to.meta.index < from.meta.index){
              this.transitionName = 'slide-right';
        }else{
              this.transitionName = 'slide-left';
        }*/
    }
  },
  mounted() {
    this.backgTheme = untils.getStore("bgTheme");
  },
  components: {},
  methods: {
    //获取请求公参
    getCommonPamas() {
      untils.removeStore("commonPamas", commonPamas);
      let commonPamas = {};
      commonPamas["lan"] = untils.getQueryString("lan") || "en";
      commonPamas["token"] =
        untils.getQueryString("token") || "a3d24efa9dc9858fbdb5276666fe0b35";
      untils.setStore("commonPamas", commonPamas);
    },
    //获取语言存于缓存
    getSetting() {
      let lan = untils.getQueryString("lan");
      let fontSize = untils.getQueryString("fontSize");
      let bgTheme = untils.getQueryString("bgTheme");
      let userId = untils.getQueryString("userId");
      untils.removeStore("lan");
      untils.removeStore("fontSize");
      untils.removeStore("bgTheme");
      untils.removeStore("userId");
      untils.setStore("lan", lan);
      untils.setStore("fontSize", fontSize);
      untils.setStore("bgTheme", bgTheme);
      untils.setStore("userId", userId);
    },
    changeSetting() {
      let lan = untils.getQueryString("lan");
      if (lan == "cn") {
        this.$i18n.locale = "cn";
      } else if (lan == "en") {
        this.$i18n.locale = "en";
      } else if (lan == "ja") {
        this.$i18n.locale = "ja";
      } else {
        this.$i18n.locale = "en";
      }
    },
    bodyTouchStart: function(event) {
      this.backBtn = document.getElementById("navback");
      if (this.backBtn) {
        // 获得起点X坐标，初始化distance为0
        this.touchStartPoint = event.targetTouches[0].pageX;
        this.distance = 0;
      }
    },
    bodyTouchMove: function(event) {
      if (this.backBtn && this.touchStartPoint < this.touchLeft) {
        // 只监听单指划动，多指划动不作响应
        if (event.targetTouches.length > 1) {
          return;
        }
        // 实时计算distance
        this.distance = event.targetTouches[0].pageX - this.touchStartPoint;
        // 根据distance在页面上做出反馈。这里演示通过返回按钮的背景变化作出反馈
        if (this.distance > 0 && this.distance < 100) {
          this.backBtn.style.backgroundPosition =
            ((this.distance - 100) / 100) * 50 + "px 0";
        } else if (this.distance >= 100) {
          this.backBtn.style.backgroundPosition = "0 0";
        } else {
          this.backBtn.style.backgroundPosition = "-50px 0";
        }
      }
    },
    bodyTouchEnd: function(event) {
      if (this.backBtn && this.touchStartPoint < this.touchLeft) {
        // 划动结束，重置数据
        this.touchStartPoint = 0;
        this.backBtn.style.backgroundPosition = "-50px 0";
        // 当划动距离超过100px时，触发返回事件
        if (this.distance > 100) {
          // 返回前修改样式，让过渡动画看起来更快
          document.getElementById("app").classList.add("quickback");
          this.$router.back();
          setTimeout(()=> {
            document.getElementById("app").classList.remove("quickback");
          }, 250);
        }
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(()=> {
        this.isRouterAlive = true;
      });
    }
  },
  computed: {}
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow-x: hidden;
}
.appView {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  transition: transform 0.24s ease-out;
  touch-action: pan-y !important;
}
#app.quickback .appView {
  transition-duration: 0.1s;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s;
  position: absolute;
  width: 100%;
  left: 0;
}
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue